import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../store';

import { TicketModel } from 'v2/types/TicketModel';

export const getTicketsListSelector = (state: RootState): TicketModel[] => state.ticketSliceReducer.ticketsList;

export const getUnassignedTicketsListSelector = (state: RootState): TicketModel[] =>
  state.ticketSliceReducer.unassignedTicketsList;

export const getTicketByIdSelector = (ticketId: string) =>
  createSelector(getTicketsListSelector, (ticketsList: TicketModel[]): TicketModel | undefined =>
    ticketsList.find((casino) => casino.id === ticketId)
  );

export const getTicketsPageSelector = (state: RootState) => state.ticketSliceReducer.ticketsPage;

export const getTicketsTotalCountSelector = (state: RootState) => state.ticketSliceReducer.ticketsTotalCount;

export const refreshTicketsTableSelector = (state: RootState) => state.ticketSliceReducer.refreshTicketsTable;
